// packages/0-foundation/core.module/src/v1/_universal/lvl_1/logger.part/utils/_parts/lvl_3/serialize-meta.util.ts

import { safeStringifyIsomorphic } from "../lvl_1";
import { createLogReplacer } from "../lvl_2";

export function serializeMeta(
  meta: unknown,
  omitKeys: string[] = [],
): unknown {
  try {
    let processed = meta;

    if (processed instanceof Error) {
      processed = {
        name: processed.name,
        message: processed.message,
        stack: processed.stack,
      };
    }

    const json = safeStringifyIsomorphic(
      processed,
      createLogReplacer(omitKeys),
      10,
      100,
    );

    const parsed: unknown = JSON.parse(json);
    return parsed;
  } catch (err) {
    const errorMsg = err instanceof Error ? err.message : String(err);
    return {
      serializationError: errorMsg,
      originalMeta: typeof meta === "string" ? meta : { type: typeof meta },
    };
  }
}
